export default "__VITE_ASSET__63fed608__"